export default __webpack_public_path__ + "static/media/05.209e650d.jpg";